export default "__VITE_ASSET__$_RBEEYU__"